module.exports = __webpack_public_path__ + "static/media/QA.b8725a54.png";